import * as PharmacyUpdateActions from '../actions/update.configuration.actions';

const initialState = {
  loading: false,
  submitSuccess: false,
  defaultLoading: false,
  defaultLoaded: false,
  defaultError: null,
  data: {
    dispensingSystem: 0,
    fredPakStatusActive: 'true',
    minfosServerURL: '',
    minfosUserName: '',
    minfosPassword: '',
    minfosBusinessCode: '',
    lotsSQLHost: '',
    lotsSQLDatabase: '',
    lotsSQLUserName: '',
    lotsSQLPassword: '',
    zsqlHost: '',
    zsqlDatabase: '',
    zsqlUserName: '',
    zsqlPassword: '',
    corumClearConnectPath: '',
    corumClearIdentifier: '',
    fredDataBaseFolder: '',
    pathForDORPTS: '',
    fredPakPath: '',
    pharmacyGuid: '',
    syncCollection: [],
    maxDaysToCheckScript: 0,
    packJobPrinting: false,
    packJobPacking: false,
    packJobChecking: false,
    packJobDistribution: false,
    packManagementDateCreatedFilter: 30,
    zapiServiceURL: '',
    zapiVendorAccessKey: '',
    zapiStoreAccessKey: '',
    zapiUserName: '',
    zapiBatchId: '',
    fredNXTAPIURL: '',
    fredNXTAccessKey: '',
    fredNXTSubscriptionKey: '',
    enableQScript: 'true',
    enableVPB: 'true',
    enableVPBHistorySummary: 'false',
    displayVPBInCheckingPhrase: 'false',
    enableDispenseTracker: 'true',
    isMypakSyncIntegrationEnabled: 'true',
    isDoseAdd: 'true',
    dwDatabase: '',
    dwHost: '',
    dwTrustedConnection: false,
    dwUserName: '',
    dwPassword: '',
    dwqScriptExportFolder: '',
    daysImportNewDrugsDispensed: 0,
    fredDispensePlusApiKey: '',
    fredDispensePlusURL: '',
    fredDispensePlusSubscriptionKey: '',
    logoutInactivityTime: 30,
    collapseMenuBar: 'false',
    useGlobalDrug: 'true',
    brandSwapProfileChangeAlert: 'true',
    readOnlyMode: false,
  },
  error: null,
  message: '',
  defaultConfig: {},
};

const configuration = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PharmacyUpdateActions.GET_PHARMACY_CONFIGURATION:
      return { ...state, error: null, message: '', loading: true };
    case PharmacyUpdateActions.GET_PHARMACY_CONFIGURATION_SUCCESS:
      return { ...state, loading: false, ...payload };
    case PharmacyUpdateActions.GET_PHARMACY_CONFIGURATION_FAIL:
      return { ...state, loading: false, message: payload.message, error: payload.error };
    case PharmacyUpdateActions.UPDATE_PHARMACY_CONFIGURATION:
      return { ...state, loading: true, submitSuccess: false, error: null, message: '' };
    case PharmacyUpdateActions.UPDATE_PHARMACY_CONFIGURATION_SUCCESS:
      return { ...state, loading: false, submitSuccess: true };
    case PharmacyUpdateActions.UPDATE_PHARMACY_CONFIGURATION_FAIL:
      return { ...state, loading: false, message: payload.message, error: payload.error };
    case PharmacyUpdateActions.CHANGE_PHARMACY_CONFIGURATION_FORM:
      return { ...state, data: { ...state.data, ...payload.data } };
    case PharmacyUpdateActions.CLEAR_PHARMACY_CONFIGURATION_FORM:
      return initialState;
    case PharmacyUpdateActions.GET_DEFAULT_DISPENSE_CONFIGURATION:
      return { ...state, defaultLoading: true, message: '', error: null, defaultError: null };
    case PharmacyUpdateActions.GET_DEFAULT_DISPENSE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        defaultLoading: false,
        defaultLoaded: true,
        defaultConfig: payload.data,
      };
    case PharmacyUpdateActions.GET_DEFAULT_DISPENSE_CONFIGURATION_FAIL:
      return {
        ...state,
        defaultLoading: false,
        defaultLoaded: true,
        defaultError: payload.message,
      };
    case PharmacyUpdateActions.CONFIG_READONLY_PHARMACY:
      return { ...state, loading: true, error: null, message: '' };
    case PharmacyUpdateActions.CONFIG_READONLY_PHARMACY_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          readOnlyMode: payload.readOnlyMode,
        },
        loading: false,
      };
    case PharmacyUpdateActions.CONFIG_READONLY_PHARMACY_FAIL:
      return { ...state, loading: false, error: payload.error, message: payload.message };
    case PharmacyUpdateActions.CONFIG_MYPAKSYNC_INTEGRATION_PHARMACY:
      return { ...state, loading: true, error: null, message: '' };
    case PharmacyUpdateActions.CONFIG_MYPAKSYNC_INTEGRATION_PHARMACY_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          isMypakSyncIntegrationEnabled: payload.isMypakSyncIntegrationEnabled,
        },
        loading: false,
      };
    case PharmacyUpdateActions.CONFIG_MYPAKSYNC_INTEGRATION_PHARMACY_FAIL:
      return { ...state, loading: false, error: payload.error, message: payload.message };
    default:
      return state;
  }
};

export default configuration;
